import React from 'react';
import { Button, Space } from 'antd';
import { ButtonProps } from 'antd/es/button';

interface Props extends ButtonProps {
  name: string;
  className?: string;
  loading?: boolean;
  children?: React.ReactNode;
}

const SubmitButton: React.FC<Props> = ({ name, type = 'default', children, ...rest }) => {
  return (
    <Button {...rest} type={type} htmlType="submit">
      <Space>
        {name}
        {children}
      </Space>
    </Button>
  );
};

export default SubmitButton;
